    
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ReviewStampedDocumentPoInstructions extends Vue {    

    @Prop({required: true})
    instructionsStep!: string;
    
}
